
export class Practicioner {
  id?: string;
  nome?: string;
  cpf?: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      let result = data.identifier.filter(item => item.system == 'http://rnds.saude.gov.br/fhir/r4/NamingSystem/cpf')[0];
      this.cpf = result.value;
      for (const item of data.name) {
        if (item.use === 'official') {
          this.nome = item.text;
        }
      }
    }
  }

  public static fromDTO?(data) {
    const pacient = new Practicioner();
    return pacient;
  }

  public toDTO?() {
    const dto: any = {};

    return dto;
  }

}
